module.exports = __webpack_public_path__ + "img/burkina-faso.3bb1818b.png";